import React, { useEffect, useRef, useState } from "react";

import "../Asociados/asociadosTable.css";

import { buildName } from "helper/tools";
import SkeletonTable from "../Skeleton/SkeletonTable";

import styles from "../Cobranza/cobranzaOther.module.css";

/**
 *
 * @param {*} param0
 * @returns
 */

export default function PaquetesProductosTable({
  items,
  openItem,
  handleSortChange,
  isLoading = false,
}) {
  const theadRef = useRef();

  const tDetalleRef = useRef([]);
  const tDetalleIsShownRef = useRef([]);

  const [areLoading, setAreLoading] = useState(false);

  function handleSort(event) {
    //data-order="desc"

    // Reference to the clicked header element
    const header = event.target;
    // Get the column to sort by from the data attribute
    const column = header.getAttribute("data-column");
    // Get the current sort order (asc or desc) from the data attribute
    const order = header.getAttribute("data-order");

    if (column?.length === 0) {
      return;
    }

    // Determine the new sort order by toggling the current order
    const newOrder = order === "desc" ? "asc" : "desc";
    // Update the data-order attribute with the new sort order
    header.setAttribute("data-order", newOrder);

    const value = event.target;

    console.log(value);

    console.log(theadRef);

    /** */
    const children = theadRef.current.children;
    for (let element of children) {
      element.classList.remove("dir-d", "dir-u");
      if (element === value) {
        const newOrderClass = newOrder === "desc" ? "dir-d" : "dir-u";
        element.classList.add(newOrderClass);
      }
    }

    handleSortChange({
      sortBy: column,
      sortAsc: newOrder,
    });
  }

  function handleDetailSort(event) {
    //data-order="desc"

    // Reference to the clicked header element
    const header = event.target;
    // Get the column to sort by from the data attribute
    const column = header.getAttribute("data-column");
    // Get the current sort order (asc or desc) from the data attribute
    const order = header.getAttribute("data-order");

    if (column?.length === 0) {
      return;
    }

    // Determine the new sort order by toggling the current order
    const newOrder = order === "desc" ? "asc" : "desc";
    // Update the data-order attribute with the new sort order
    header.setAttribute("data-order", newOrder);

    const value = event.target;

    console.log(value);

    console.log(theadRef);

    /** */
    const children = theadRef.current.children;
    for (let element of children) {
      element.classList.remove("dir-d", "dir-u");
      if (element === value) {
        const newOrderClass = newOrder === "desc" ? "dir-d" : "dir-u";
        element.classList.add(newOrderClass);
      }
    }

    /*  handleSortChange({
      sortBy: column,
      sortAsc: newOrder,
    });*/
  }

  async function toggleDetails(index, asociadoId) {
    console.log(items);

    showClienteRow(index);
  }

  function showClienteRow(index) {
    const newloading = !areLoading;
    setAreLoading(newloading);

    if (!tDetalleIsShownRef.current[index]) {
      tDetalleIsShownRef.current[index] = false;

      setTimeout(function () {
        tDetalleRef.current[index].style.display = "flex";
        tDetalleIsShownRef.current[index] = true;
        setAreLoading(!newloading);
      }, 100);
    } else {
      tDetalleIsShownRef.current[index] = true;

      setTimeout(function () {
        tDetalleRef.current[index].style.display = "none";
        tDetalleIsShownRef.current[index] = false;
        setAreLoading(!newloading);
      }, 100);
    }

    /*if (items[index].clientes.length === 0) {
      //} == null) {
      tDetalleIsShownRef.current[index] = true;

      const newloading = !areLoading;
      setAreLoading(newloading);

      setTimeout(function () {
        //  handleDetail(index, () => {
        tDetalleRef.current[index].style.display = "flex";
        tDetalleIsShownRef.current[index] = true;
        setAreLoading(!newloading);

        //  setAsociadosClientes({ index: index });
        //  });
      }, 500);

      /*  /
      return;
    }
    if (tDetalleIsShownRef.current[index] == null) return;
    tDetalleIsShownRef.current[index] = !tDetalleIsShownRef.current[index];
    tDetalleRef.current[index].style.display = tDetalleIsShownRef.current[index]
      ? "none"
      : "flex";

    setAreLoading(tDetalleIsShownRef.current[index]);
    */
  }

  useEffect(() => {
    tDetalleIsShownRef.current.length = 0;
    tDetalleIsShownRef.current = new Array(items.length).fill(false);
  }, [items]);

  return (
    <>
      <table
        className="table table-borderless datable sortable table-hover"
        style={{ tableLayout: "fixed" }}
      >
        <thead className="table-light" style={{ textAlign: "center" }}>
          <tr ref={theadRef}>
            <th
              scope="col"
              data-column="id"
              style={{ width: "100px" }}
              onClick={(event) => handleSort(event)}
            >
              Id
            </th>

            <th
              scope="col"
              data-column="nombre"
              onClick={(event) => handleSort(event)}
              style={{
                position: "absolute",
                textAlign: "center",
                width: "80%",
              }}
            >
              Nombre
            </th>
          </tr>
        </thead>
        <tbody>
          {isLoading && <SkeletonTable columnCount={6} rowCount={4} />}

          {!isLoading &&
            items?.length > 0 &&
            items?.map((item, index) => {
              //  const imagePaths = item.productImagePathsString?.split(",") ?? [];
              //  const imagePath = imagePaths.length > 0 ? imagePaths[0] : "";
              //  const imageURL = ImagePathBuilder.to(imagePath);

              const productos = item.productos;

              const isClientLoading =
                tDetalleIsShownRef.current[index] && productos.length === 0;

              return (
                <>
                  <tr
                    key={item.id}
                    onClick={(event) => toggleDetails(index, item.id)}
                  >
                    <th
                      scope="row"
                      style={{
                        verticalAlign: "middle",
                        justifyItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <a href="#" onClick={(e) => openItem(item)}>
                        {item.id ?? ""}
                      </a>
                    </th>
                    {/**  <td>
                    <a href="#" onClick={(e) => openItem(item)}>
                      {item.sku ?? ""}
                    </a>
                  </td>
                   */}
                    <td
                      style={{
                        position: "absolute",
                        textAlign: "left",
                        width: "80%",
                      }}
                    >
                      <a href="#" onClick={(e) => openItem(item)}>
                        {item.nombre ?? ""}
                      </a>
                    </td>

                    {/* <td>{item.descripcion ?? ""}</td>
                 <td style={{ width: "100%", height: "100%" }}>
                    <div
                      className=""
                      style={{
                        overflow: "auto",
                        width: "100%",
                      }}
                    >
                      {item.tagsProducto.map((tag) => {
                        return (
                          <>
                            <span className={"badge bg-primary"}>
                              {tag.nombre ?? ""}
                            </span>
                          </>
                        );
                      })}
                    </div>
                  </td>
                   */}
                  </tr>
                  <tr
                    style={{
                      borderBottomColor: "transparent",
                    }}
                  >
                    <td
                      colSpan="12"
                      style={{
                        paddingTop: "0px",
                        paddingBottom: "0px",
                        backgroundColor: "aliceblue",
                      }}
                    >
                      {/*<!-- Inner Table starts here -->*/}

                      {isClientLoading && (
                        <table
                          className="table table-borderless datable sortable table-hover"
                          style={{ backgroundColor: "lightcoral" }}
                          width="100%"
                        >
                          <tbody>
                            <SkeletonTable columnCount={7} rowCount={6} />
                          </tbody>
                        </table>
                      )}
                      <div
                        className=""
                        ref={(el) => (tDetalleRef.current[index] = el)}
                        style={{ display: "none" }}
                      >
                        {productos.length === 0 ? (
                          <></>
                        ) : (
                          <>
                            <div className="col-1"></div>
                            <div className="col-11">
                              <table
                                className="table table-borderless datable sortable table-hover"
                                style={{ backgroundColor: "lightcoral" }}
                                width="100%"
                              >
                                <thead
                                  className="table-light"
                                  style={{ textAlign: "center" }}
                                >
                                  <tr className={styles.has_tr}>
                                    <th
                                      scope="col"
                                      data-column="detalle.id"
                                      style={{
                                        width: "90px",
                                        verticalAlign: "middle",
                                      }}
                                      onClick={(event) =>
                                        handleDetailSort(event)
                                      }
                                    >
                                      Id
                                    </th>
                                    <th
                                      scope="col"
                                      data-column="detalle.nombre"
                                      style={{
                                        textAlign: "center",
                                        width: "130px",
                                        verticalAlign: "middle",
                                      }}
                                      onClick={(event) =>
                                        handleDetailSort(event)
                                      }
                                    >
                                      Nombre
                                    </th>

                                    <th
                                      scope="col"
                                      data-column="detalle.marca"
                                      style={{
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                      }}
                                      onClick={(event) =>
                                        handleDetailSort(event)
                                      }
                                    >
                                      Marca
                                    </th>

                                    <th
                                      scope="col"
                                      data-column="detalle.genero"
                                      style={{
                                        textAlign: "center",
                                        width: "130px",
                                        verticalAlign: "middle",
                                      }}
                                      onClick={(event) =>
                                        handleDetailSort(event)
                                      }
                                    >
                                      <span>Genero</span>
                                    </th>

                                    <th
                                      scope="col"
                                      data-column="detalle.tamaño"
                                      style={{
                                        textAlign: "center",
                                        width: "150px",
                                        verticalAlign: "middle",
                                      }}
                                      onClick={(event) =>
                                        handleDetailSort(event)
                                      }
                                    >
                                      Tamaño
                                    </th>

                                    <th
                                      scope="col"
                                      data-column="detalle.concentracion"
                                      style={{
                                        textAlign: "center",
                                        width: "140px",
                                        verticalAlign: "middle",
                                      }}
                                      onClick={(event) =>
                                        handleDetailSort(event)
                                      }
                                    >
                                      Concentración
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {productos.map((item, index) => {
                                    const producto = item.producto;

                                    let nombre = "";
                                    let marca = "";
                                    let genero = "";
                                    let tamano = "";
                                    let concentracion = "";

                                    if (producto != null) {
                                      nombre = buildName(producto, true);
                                      marca = producto.marca?.nombre ?? "";
                                      genero = producto.genero?.nombre ?? "";
                                      tamano = producto.tamaño?.nombre ?? "";
                                      concentracion =
                                        producto.concentracion?.nombre ?? "";
                                    }

                                    const numProducto = producto?.id ?? "-";

                                    return (
                                      <tr className={styles.has_tr}>
                                        <td
                                          style={{
                                            textAlign: "center",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          <a
                                            href="#"
                                            onClick={(e) =>
                                              openItem({
                                                ...item,
                                                item,
                                              })
                                            }
                                          >
                                            {numProducto}
                                          </a>
                                        </td>
                                        <td>{nombre}</td>
                                        <td style={{ textAlign: "center" }}>
                                          {marca}
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                          {genero}
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                          {tamano}
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                          {concentracion}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </>
                        )}
                      </div>
                      {/*<!-- Inner Table ends here -->*/}
                    </td>
                  </tr>
                </>
              );
            })}
        </tbody>
      </table>
    </>
  );
}
